import React from 'react';
import { Tabs, Tab } from '@material-ui/core';

export const FilterTabs = ({ filters, onFilterSelect, selectedFilter }) => {

  let index = selectedFilter;
  if(filters[0].FEED_ID || filters[0].CALENDAR_ID) {
    index = selectedFilter;
  } else if (selectedFilter) {
    index = filters.findIndex(filter => filter === selectedFilter) + 1
  } else {
    index = 0;
  }


  const onIndexSelect = (e, index) => {
    const moduleFilter = filters[0].CALENDAR_ID ? true : filters[0].FEED_ID ? true : false;
    // see if we have rss style feeds for filters
    if(moduleFilter) {
      onFilterSelect(index);
    } else {
      onFilterSelect(index === 0 ? '' : filters[index - 1]);
    }    
  }

  const tabs = filters ? filters.map(filter => {
    const tab = filter.FEED_ID
    ? <Tab key={filter.FEED_ID} label={filter.FEED_TITLE} />
    : filter.CALENDAR_ID
      ? <Tab key={filter.CALENDAR_ID} label={filter.CALENDAR_TITLE} />
      : <Tab key={filter} label={filter} />
    return tab;
    }) : null;
  return (
      <Tabs
        value={index}
        onChange={onIndexSelect}
        // style={{maxWidth: '95%'}}
        // centered
        scrollable
        // fullWidth
        // textColor='inherit'
        // indicatorColor='secondary'
      >
        <Tab key={0} label='All' />
        {tabs}
      </Tabs>
  )
}


// WEBPACK FOOTER //
// ./src/components/containers/FilterTabs.js